<template>
  <section class="main_wrap">
    <!--工具条-->
    <el-col :span="24" class="toolbar search-bar" style="padding-bottom: 0px;">
        <el-input v-model="keyword" placeholder="请输入bus_app_id" @keyup.enter.native="getUsers"></el-input>
        <el-button type="primary" @click="getUsers">查询</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="contracts" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="ID"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.app_id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="withdraw_status" width="">
        <template slot-scope="scope">
          <span>{{scope.row.withdraw_status}}</span>
        </template>
      </el-table-column>
      <el-table-column label="withdraw_status_desc" min-width="">
        <template slot-scope="scope">
          <span>{{ scope.row.withdraw_status_desc }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <span class="total_number" style="margin-top: 7px;display: inline-block;"> 共计 <span v-model="total_count"> {{total_count}} </span> 条 </span>
      <el-pagination
        v-show="pagination"
        style="float:right;"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="prev, pager, next, jumper"
        :total="total_count">
      </el-pagination>
    </el-col>
  </section>
</template>
<script>
    import { BusInstallment } from '../../api/api';
    export default {
      data() {
        return {
          keyword: '',
          //===有分页会用到
          currentPage: 1,
          listLoading: false,
          total_count: 0,
          pagination: true,
          //=====
          contracts: []
        }
      },
      methods: {
        getUsers() {
          let params = {
            'bus_app_id': this.keyword,
             'page':      this.currentPage
          };
          BusInstallment(params).then((res) => {
            if(res.status === 0){
              this.contracts = res.data.bus_installments;
              this.total_count =res.data.bus_installments.length;
            }
          })
        },
        handleCurrentChange(val) {
          this.currentPage = val;
          this.getUsers();
        },
      }
    }

</script>

<style lang="scss">
  @import "../../assets/css/common.scss";
</style>



// WEBPACK FOOTER //
// src/views/tableList/BusInstallment.vue